import { useAuthStore } from '@/core/stores/authStore';

export default function FamilyDashboard() {
  const { user } = useAuthStore();
  
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-display-lg text-navy">Good morning, {user?.first_name}</h1>
        <p className="text-warm-gray">Here's your family's care overview</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {[
          { label: 'Therapy Sessions', value: '12', change: '+2 this month' },
          { label: 'Seizure-Free Days', value: '28', change: 'Personal best!' },
          { label: 'IEP Goals Progress', value: '67%', change: 'On track' },
          { label: 'YTD Expenses', value: '$4,230', change: 'Tax-ready' },
        ].map((stat) => (
          <div key={stat.label} className="card">
            <p className="text-sm text-warm-gray mb-1">{stat.label}</p>
            <p className="font-display text-3xl font-semibold text-navy">{stat.value}</p>
            <p className="text-xs text-success mt-1">{stat.change}</p>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        {/* Recent Activity */}
        <div className="lg:col-span-2 card">
          <h2 className="font-display text-heading-md mb-4">Recent Activity</h2>
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center gap-4 p-3 bg-cream rounded-md">
                <div className="w-10 h-10 bg-sage/15 rounded-md flex items-center justify-center text-sage">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div className="flex-1">
                  <p className="font-medium text-navy">Activity {i}</p>
                  <p className="text-sm text-warm-gray">Description here</p>
                </div>
                <span className="text-xs text-warm-gray">2h ago</span>
              </div>
            ))}
          </div>
        </div>

        {/* Upcoming */}
        <div className="card">
          <h2 className="font-display text-heading-md mb-4">Upcoming</h2>
          <div className="space-y-3">
            {[
              { day: '15', month: 'Dec', title: 'Neurology Follow-up' },
              { day: '17', month: 'Dec', title: 'OT Session' },
              { day: '20', month: 'Dec', title: 'IEP Review Meeting' },
            ].map((event) => (
              <div key={event.title} className="flex items-center gap-3 p-3 bg-cream rounded-md border-l-2 border-sage">
                <div className="text-center min-w-[45px]">
                  <p className="font-display text-xl font-semibold text-sage leading-none">{event.day}</p>
                  <p className="text-xs text-warm-gray uppercase">{event.month}</p>
                </div>
                <div>
                  <p className="font-medium text-navy">{event.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

